import { api } from "./client";
import { LeaveQuota } from "@/types";

export const leaveQuotaService = {
  getAll: async () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await api.get("leave-quotas");
    // Depending on backend response structure, adjust accordingly.
    // Assuming standard responseBody.data pattern
    return response.responseBody.data as LeaveQuota[];
  },

  getByYear: async (year: number) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await api.get(`leave-quotas/${year}`);
    return response.responseBody.data as LeaveQuota;
  },

  create: async (data: LeaveQuota) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await api.post("leave-quotas", data);
    return response.responseBody.data as LeaveQuota;
  },

  update: async (year: number, data: Partial<LeaveQuota>) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response: any = await api.put(`leave-quotas/${year}`, data);
    return response.responseBody.data as LeaveQuota;
  },

  delete: async (year: number) => {
    await api.delete(`leave-quotas/${year}`);
  },
};
